const storageKey = (sessionId: string) => `ppui:overdue-repayment:${sessionId}`;

/** Remember pay-overdue flow across session refetches (e.g. after settlement). */
export function latchOverdueRepaymentFlow(sessionId: string): void {
  try {
    sessionStorage.setItem(storageKey(sessionId), "1");
  } catch {
    // sessionStorage may be unavailable in some environments
  }
}

export function hasLatchedOverdueRepaymentFlow(sessionId: string): boolean {
  try {
    return sessionStorage.getItem(storageKey(sessionId)) === "1";
  } catch {
    return false;
  }
}

export function clearLatchedOverdueRepaymentFlow(sessionId: string): void {
  try {
    sessionStorage.removeItem(storageKey(sessionId));
  } catch {
    // ignore
  }
}
